import React from 'react';

const ConditionalWrapper = ({ condition, wrapper, children }) => {
    if (condition) {
        if (React.isValidElement(wrapper)) {
            return React.cloneElement(wrapper, {}, children);
        }
        const WrapperComponent = wrapper;
        return React.createElement(WrapperComponent, null, children);
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null, children);
};

export { ConditionalWrapper as C };
//# sourceMappingURL=ConditionalWrapper-6zYfwfM_.js.map
